import React from 'react'

import { PSmaller, TextButton } from '@guiker/components-library'
import { useTranslation } from '@guiker/i18n'

type ButtonProps = {
  hide: boolean
  setHide: (value: boolean) => void
}

const CollapsibleDescriptionButton: React.FC<ButtonProps> = ({ hide, setHide }) => {
  const { t } = useTranslation('common')

  return (
    <TextButton size='small' onClick={() => setHide(!hide)}>
      <PSmaller mb={0}>{t(`actions.${hide ? 'seeMore' : 'seeLess'}`)}</PSmaller>
    </TextButton>
  )
}

export { CollapsibleDescriptionButton }
